function blockBuyButtonsClicks(e) {
    if (e.target.closest('.product .buy-buttons button')) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();
    }
}
// initally block buy button click
document.addEventListener('click', blockBuyButtonsClicks, true);

// once the page is fully loaded, enable the click
window.onload = function() {
    document.removeEventListener('click', blockBuyButtonsClicks, true);
};
